/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChargingConfiguration } from '../../models/charging-configuration';

export interface ApiChargingConfigurationGetChargingConfigurationWithParkingPlaceAndParkingSpotsByParkingPlaceIdGet$Json$Params {
  parkingPlaceId?: number;
}

export function apiChargingConfigurationGetChargingConfigurationWithParkingPlaceAndParkingSpotsByParkingPlaceIdGet$Json(http: HttpClient, rootUrl: string, params?: ApiChargingConfigurationGetChargingConfigurationWithParkingPlaceAndParkingSpotsByParkingPlaceIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargingConfiguration>> {
  const rb = new RequestBuilder(rootUrl, apiChargingConfigurationGetChargingConfigurationWithParkingPlaceAndParkingSpotsByParkingPlaceIdGet$Json.PATH, 'get');
  if (params) {
    rb.query('parkingPlaceId', params.parkingPlaceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChargingConfiguration>;
    })
  );
}

apiChargingConfigurationGetChargingConfigurationWithParkingPlaceAndParkingSpotsByParkingPlaceIdGet$Json.PATH = '/api/ChargingConfiguration/GetChargingConfigurationWithParkingPlaceAndParkingSpotsByParkingPlaceId';
